import React, { Component } from "react";

import BillingOrderRow from "./BillingOrderRow";
import BillingOrderLineRow from "./BillingOrderLineRow";
import {searchFilterService} from "../../Services/SearchFilterService.js";

import { withStyles } from '@material-ui/core/styles';
//import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


const styles = theme => ({
	[theme.breakpoints.down('sm')]:{
		bigcell: {
			maxWidth:'150px',
			minWidth:'50px'
		},
		medcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
		smallcell: {
			maxWidth:'15px',
			minWidth:'15px'
		},
	},
	[theme.breakpoints.up('md')]:{
		bigcell: {
			maxWidth:'150px',
			minWidth:'50px'
		},
		medcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
		smallcell: {
			maxWidth:'50px',
			minWidth:'50px'
		},
	},
	setoverflow:{
		overflow:'hidden',
		display: 'block'
	}
});
class BillingList extends Component {
	constructor(props) {
        super(props);
		this.state={
			desplegat: -1
		};
		this.desplega = this.desplega.bind(this);
		this.header = this.header.bind(this);
		this.format = this.format.bind(this);
		this.haveReference = this.haveReference.bind(this);
		this.analiticAccountColumn = this.analiticAccountColumn.bind(this);
		this.referenceColumn = this.referenceColumn.bind(this);
		this.userColumn = this.userColumn.bind(this);
    }
	
	desplega(index){
		if(this.state.desplegat==index){
			this.setState({desplegat: -1});
		}else{
			this.setState({desplegat: index});
		}
	}
	
	haveReference(){
		let ref = false;
		for (var orderIndex = 0; orderIndex < this.props.billing.length; orderIndex++) {
			if(typeof this.props.billing[orderIndex].lines !== "undefined" && this.props.billing[orderIndex].lines != null){
						let billingLines = ((typeof this.props.search !== 'undefined') && (this.props.search.length > 0)) ? (this.props.billing[orderIndex].lines.filter(line => line.analiticAccount.toUpperCase().includes(this.props.search.toUpperCase()))) : (this.props.billing[orderIndex].lines);
						for (var lineIndex = 0; lineIndex < billingLines.length; lineIndex++) {
							if(billingLines[lineIndex].reference!=""){
								ref = true;
							}
						}
			}
		}
		return ref;
	}
	
	userColumn(){
		if(this.props.role=='CUSTOMER'){
			return <TableCell style={{fontWeight: "bold"}}>User</TableCell>
		}else{
			return "";
		}
	}
	referenceColumn(printReference){
		if(printReference){
			return <TableCell style={{fontWeight: "bold"}}>Reference</TableCell>
		}else{
			return "";
		}
	}
	analiticAccountColumn(){
		if(this.props.role=='CUSTOMER'){
			return "";
		}else{
			return <TableCell style={{fontWeight: "bold"}}>Customer</TableCell>
		}
	}
	
	header(printReference){
		return <TableRow style={{background: '#dfe3ea', color: "#000", cursor: "pointer"}}>
				<TableCell style={{fontWeight: "bold"}} className={this.props.classes.smallcell}>CODE</TableCell>
				{this.userColumn()}
		        <TableCell style={{fontWeight: "bold"}} className={this.props.classes.bigcell}>Product</TableCell>
				<TableCell style={{fontWeight: "bold"}} className={this.props.classes.bigcell}>Document name</TableCell>
				{this.referenceColumn(printReference)}
				{this.analiticAccountColumn()}
				<TableCell style={{fontWeight: "bold"}}>Date</TableCell>
				<TableCell style={{fontWeight: "bold", textAlign:"right"}} className={this.props.classes.smallcell}>Units</TableCell>
				<TableCell style={{fontWeight: "bold", textAlign:"right"}}>Unit Price</TableCell>
				<TableCell style={{fontWeight: "bold", textAlign:"right"}}>Subtotal</TableCell>
				<TableCell style={{fontWeight: "bold", textAlign:"right"}}>Total</TableCell>
		      </TableRow>
	}
	
	format(value, decimals){
		let parts = value.split("\.");
		let decPart = parts[1]+"";
		if(parts.length==2){
			let len = parts[1].length;
			if(len>decimals){
				decPart = parts[1].substring(0,decimals);
			}else if(len<decimals){
//				console.log(len+"<"+decimals+" : "+decPart);
				while(decPart.length<decimals){
					decPart+="0";
//					console.log(decPart);
				}
			}
//			console.log("("+value+","+decimals+") => "+parts[0]+","+decPart);
			return parts[0]+","+decPart;
		}else{
//			console.log("("+value+","+decimals+") NOP "+value);
			return value;
		}
	}
	
	render() {
		let rows = [];
		if(this.props.billing){
			let printReference = this.haveReference();
			for (var orderIndex = 0; orderIndex < this.props.billing.length; orderIndex++) {
				rows.push(	<BillingOrderRow
								id={this.props.billing[orderIndex].id}
								code={this.props.billing[orderIndex].code}
								date={this.props.billing[orderIndex].date}
								total={this.format(this.props.billing[orderIndex].totalAmount, 2)}
								index={orderIndex}
								desplega={this.desplega}
								role={this.props.role}
								printReference={printReference}
							/>
				)
				if(this.state.desplegat===orderIndex){
					rows.push(this.header(printReference));
					if(typeof this.props.billing[orderIndex].lines !== "undefined" && this.props.billing[orderIndex].lines != null){
						let billingLines = ((typeof this.props.search !== 'undefined') && (this.props.search.length > 0)) ? (this.props.billing[orderIndex].lines.filter(line => line.analiticAccount.toUpperCase().includes(this.props.search.toUpperCase()))) : (this.props.billing[orderIndex].lines);
//						console.log(billingLines);
						for (var lineIndex = 0; lineIndex < billingLines.length; lineIndex++) {
							rows.push(	<BillingOrderLineRow
											id={billingLines[lineIndex].id}
											code={billingLines[lineIndex].code}
											product={billingLines[lineIndex].product}
											qty={billingLines[lineIndex].qty}
											docName={billingLines[lineIndex].docName}
											date={billingLines[lineIndex].date}
											unitPrice={this.format(billingLines[lineIndex].unitPrice, 4)}
											subtotal={this.format(billingLines[lineIndex].subtotal, 4)}
											total={this.format(billingLines[lineIndex].total, 2)}
											analiticAccount={billingLines[lineIndex].analiticAccount}
											role={this.props.role}
											printReference={printReference}
											user = {billingLines[lineIndex].user}
											reference = {billingLines[lineIndex].reference}
										/>
							)
						}
					}
				}
			}
		}
		
		return (
		<div className="content">
		  <Table stickyHeader className="lst">
		    <TableBody>{rows}</TableBody>
		  </Table>
		</div>
		);
  }
};

export default withStyles(styles)(BillingList);